// Deps
import request from 'utils/request'
import config from 'config'
import endOfDay from 'date-fns/endOfDay'
import parseISO from 'date-fns/parseISO'
import formatISO from 'date-fns/formatISO'
//import store from 'store'

// Functions
import submitVirtualForm from 'functions/submit-virtual-form'

// Actions
//import { setData, setInitialized, setRefreshToken, setAccessToken, setAccountCode } from 'store/user/actions'

const orderServices = {
	// Orders
	expressOrder: (inputParams) => {
		return new Promise((resolve, reject) => {
			try {
				let params = {...inputParams}
				if (params.order_due_date) {
					params.order_due_date = formatISO(endOfDay(parseISO(params.order_due_date))).split('+')[0];
				}

				request.post(
					'express-client-order',
					params,
					(payload, status, request) => {
						if(status === 200 && payload) {
							resolve(payload);
						}
						else {
							reject(false);
						}
					}
				);
			}
			catch(e) { console.warn('Create order error: ', e); }
		});
	},
	createPosOrder: (amount, groupID, description) => {
		return new Promise((resolve, reject) => {
			//let userState = store.getState()['user'];

			if(!description || description.length === 0) {
				description = 'POS Ödemesi';
			}

			request.post('express-client-order', {
				create_or_update_client: 'update',
				create_or_update_order: 'create',
				client_code: 'anonim',
				//company_account_code: userState.accountCode,
				order_total_amount: amount,
				order_price_type_id: 1,
				order_store_code: groupID,
				order_description: description,
				order_due_date: endOfDay(new Date()),
			}, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	getOrder: (orderCode) => {
		return new Promise((resolve, reject) => {
			request.post('get-order', { order_business_code: orderCode }, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	deleteOrder: (orderCode) => {
		return new Promise((resolve, reject) => {
			request.post('delete-order', { order_business_code: orderCode }, (payload, status, request) => {
				if(status === 200 && request.data.status === 'success') {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	cancelOrder: (payload) => {
		return new Promise((resolve, reject) => {
			request.post('cancel-order', payload, (payload, status, request) => {
				if(status === 200 && request.data.status === 'success') {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	listOrders: (params = {}) => {
		const defaultParams = {
			page: 1,
			per_page: 10,
		}

		return new Promise((resolve, reject) => {
			request.post('list-orders', {...defaultParams, ...params}, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve({
						orders: payload,
						pagination: request.data.paginate
					});
				}
				else {
					reject(false);
				}
			});
		});
	},
	createOrderNote: (orderID, note) => {
		return new Promise((resolve, reject) => {
			let params = {
				order_business_code: orderID,
				order_note: note,
				process_type: 'create',
			}

			request.post(
				'express-order-note',
				params,
				(payload, status, request) => {
					if (status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(false);
					}
				}
			);
		});
	},
	deleteOrderNote: (orderID, noteID) => {
		return new Promise((resolve, reject) => {
			let params = {
				order_business_code: orderID,
				process_type: 'delete',
				order_note_id: noteID,
			}

			request.post(
				'express-order-note',
				params,
				(payload, status, request) => {
					if (status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(false);
					}
				}
			);
		});
	},
	updateProductStatus: (orderID, status) => {
		return new Promise((resolve, reject) => {
			request.post('update-order-products-status', { order_business_code: orderID, product_status: status }, (payload, status, request) => {
				if (status === 200) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	// Payment
	listOrdersForPayment: (clientCode, queryValue, companySubURL = false, page = 1, statusCode = false, excelQuery = false) => {
		return new Promise((resolve, reject) => {
			let params = { client_code: clientCode, page: page };

			if(companySubURL) {
				params.company_sub_url = companySubURL;
				params.client_tax_number = queryValue;
			}
			else {
				params.order_code = queryValue;
			}

			if(statusCode !== false) {
				params.status_code = statusCode
			}
			if(excelQuery) {
				params.page = 1;
				params.per_page = 100000;
			}

			request.post('list-orders-for-pay', params, (payload, status, request) => {
				if(status === 200 && payload) {
					let resolveData = {
						orders: payload,
						client_custom_order: request.data.inputs.client_custom_order,
						pagination: request.data.paginate
					};

					if(companySubURL) {
						resolveData.client_custom_order = request.data.inputs.client_custom_order;
					}

					resolve(resolveData);
				}
				else {
					reject(false);
				}
			});
		});
	},
	getOrderForPayment: (orderCode) => {
		return new Promise((resolve, reject) => {
			request.post('get-order-detail-for-pay', { order_code: orderCode }, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	getInstallmentsForPayment: (orderCode, binNumber, price) => {
		return new Promise((resolve, reject) => {
			request.post('get-installments-for-pay', { order_code: orderCode, bin_number: binNumber, price: price }, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	refundPayment: (params = {}) => {
		return new Promise((resolve, reject) => {
			request.post('refund-payment', params, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	updateAnonymousClientForPayment: (params = {}) => {
		return new Promise((resolve, reject) => {
			request.post('update-anonim-client-for-pay', params, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	getCompanyCards: () => {
		return new Promise((resolve, reject) => {
			request.post('express-company-cards', {}, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	removeCompanyCard: (cardID) => {
		return new Promise((resolve, reject) => {
			request.post('express-company-cards', { card_id: cardID, process_type: 'delete' }, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	setCardAutoPayment: (cardID, active = true) => {
		return new Promise((resolve, reject) => {
			request.post('express-company-cards', { card_id: cardID, process_type: 'autopay', autopay: active ? '1' : '0' }, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	// 3D Payment
	make3dPayment: (params = {}) => {
		submitVirtualForm(config.apiURL + 'pay3d', params);
	},
	make3dBalancePayment: (params = {}) => {
		return new Promise((resolve, reject) => {
			request.post('load-balance-pay3d', params, (payload, status, request) => {
				if (status === 200 && payload) {
					document.querySelector('html').innerHTML = payload;

					setTimeout(() => {
						document.querySelector("form").submit();
					}, 250);
				}
				else {
					reject(false);
				}
			});
		});
		// submitVirtualForm(config.apiURL + 'load-balance-pay3d', params);
	},
	// Order Plans
	listOrderPlans: (params = {}) => {
		const defaultParams = {
			page: 1,
			per_page: 10,
		}
		return new Promise((resolve, reject) => {
			request.post('list-order-plans', {...defaultParams, ...params}, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve({
						plans: payload,
						pagination: request.data.paginate,
					});
				}
				else {
					reject(request);
				}
			});

		});
	},
	getOrderPlan: (orderPlanID) => {
		return new Promise((resolve, reject) => {
			request.post('get-order-plan', { order_plan_id: orderPlanID }, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	updateOrderPlan: (params) => {
		return new Promise((resolve, reject) => {
			request.post(
				'update-order-plan',
				params,
				(payload, status, request) => {
					if (status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(false);
					}
				}
			);
		});
	},
	deleteOrderPlan: (planID) => {
		return new Promise((resolve, reject) => {
			request.post('delete-order-plan', { order_plan_id: planID }, (payload, status, request) => {
				if(status === 200 && request.data.status === 'success') {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	createPeriodToOrderPlan: (planID) => {
		return new Promise((resolve, reject) => {
			request.post('create-order-by-plan', { order_plan_id: planID }, (payload, status, request) => {
				if(status === 200 && request.data.status === 'success') {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	calculateOrderPlan: (periodTime, periodTimeRange, periodCount, startDate, dueDate, totalAmount, planID = '') => {
		return new Promise((resolve, reject) => {
			request.post(
				'calculate-order-plan',
				{
					order_period_time: periodTime,
					order_period_time_range: periodTimeRange,
					order_period_count: periodCount,
					order_start_date: startDate,
					order_due_date: dueDate,
					order_total_amount: totalAmount,
					order_plan_id: planID
				}, (payload, status, request) => {
				if (status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(request);
					}
				}
			);
		});
	},
	// Order Templates
	getOrderTemplate: (templateID) => {
		return new Promise((resolve, reject) => {
			request.post('get-order-template', { order_template_id: templateID }, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	updateOrderTemplate: (params) => {
		return new Promise((resolve, reject) => {
			//let userState = store.getState()['user'];

			request.post(
				'update-order-template',
				params,
				(payload, status, request) => {
					if (status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(false);
					}
				}
			);
		});
	},
	createOrderFromTemplate: (token) => {
		return new Promise((resolve, reject) => {
			request.post('create-order-by-template', { token: token }, (payload, status, request) => {
				if (status === 200 && request.data.status === 'success') {
					resolve(payload);
				}
				else {
					reject(false);
				}
			}, {showMessages: false});
		});
	},
	deleteOrderTemplate: (templateID) => {
		return new Promise((resolve, reject) => {
			request.post('delete-order-template', { order_template_id: templateID }, (payload, status, request) => {
				if (status === 200 && request.data.status === 'success') {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	listOrderTemplates: (params = {}) => {
		const defaultParams = {
			page: 1,
			per_page: 10,
		}
		return new Promise((resolve, reject) => {
			request.post('list-order-templates', {...defaultParams, ...params}, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve({
						templates: payload,
						pagination: request.data.paginate,
					});
				}
				else {
					reject(request);
				}
			});

		});
	},
	// Payments
	listPayments: (params = {}) => {
		const defaultParams = {
			page: 1,
			per_page: 10,
		}

		return new Promise((resolve, reject) => {
			request.post('list-payments', {...defaultParams, ...params}, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve({
						payments: payload,
						pagination: request.data.paginate
					});
				}
				else {
					reject(false);
				}
			});
		});
	},
	listPaymentRefunds: (params = {}) => {
		const defaultParams = {
			page: 1,
			per_page: 10,
		}

		return new Promise((resolve, reject) => {
			request.post('list-payments-refunds', {...defaultParams, ...params}, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve({
						refunds: payload,
						pagination: request.data.paginate
					});
				}
				else {
					reject(false);
				}
			});
		});
	},
	// Custom Order
	listCustomOrderGroups: (confirmToken) => {
		return new Promise((resolve, reject) => {
			request.post('list-custom-order-groups-for-pay', { confirm_token: confirmToken }, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(payload);
				}
				else {
					reject(false);
				}
			});
		});
	},
	// Notifications
	sendNotification: (params = {}) => {
		return new Promise((resolve, reject) => {
			request.post('order-info-notify', params, (payload, status, request) => {
				if(status === 200 && payload) {
					resolve(true);
				}
				else {
					reject(false);
				}
			});
		});
	},
}

export default orderServices;
